<lib-dba-mat-dialog-title (cancelClick)="Abbrechen()">
  {{Title}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <lib-select-create formControlName="debitorControl" [selectList]="debitorList" selectValue="DebitorID"
    [selectNameList]="['Nummer','Name','PLZ','Ort','LandName']" [label]="language.debitor | translationPipe"
    [showDeselect]="false" [showCreate]="false">
  </lib-select-create>

  <mat-form-field>
    <mat-label>{{language.Bezeichnung | translationPipe}}</mat-label>
    <input matInput maxlength="100" formControlName="bezeichnungControl">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{language.Strasse | translationPipe}}</mat-label>
    <input matInput maxlength="100" formControlName="strasseControl">
  </mat-form-field>

  <div class="row">
    <mat-form-field>
      <mat-label>{{language.PLZ | translationPipe}}</mat-label>
      <input matInput maxlength="7" formControlName="plzControl">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.Ort | translationPipe}}</mat-label>
      <input matInput maxlength="100" formControlName="ortControl">
      <mat-icon *ngIf="this.OrtControl.value!='' && this.PLZControl.value!='' && this.StrasseControl.value!=''"
        (click)="openMaps()" matSuffix>public</mat-icon>
    </mat-form-field>
  </div>

  <lib-select-create formControlName="landControl" [selectList]="landList" selectValue="LandID" selectName="LandName"
    [label]="language.Land | translationPipe" [showDeselect]="false" [showCreate]="false">
  </lib-select-create>
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="Abbrechen()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>